import { useApi } from "../../../swr/useApi";
import {
  paymentsMeService,
  purchaseOrdersService,
} from "../../api_client";
import type { PendingReleaseSummaryDto, TopProductDto } from "../../../api";

export function usePendingRelease() {
  return useApi<PendingReleaseSummaryDto>("payments-me-pending-release", () =>
    paymentsMeService.getMyPendingRelease(),
  );
}

export interface TopSellerProductsParams {
  period?: "7d" | "30d" | "90d" | "year";
  limit?: number;
}

/**
 * Backend renamed `limit` → `take` on `TopProductsQueryDto` to break the
 * codegen heuristic that was folding the DTO into `ProductsQueryDto`. After
 * the next `npm run generate:api` the typed signature should expose
 * `{ period, take }` directly and the cast below can be dropped.
 */
export function useTopSellerProducts(params: TopSellerProductsParams = {}) {
  const period = params.period ?? "30d";
  const take = params.limit ?? 4;
  return useApi<TopProductDto[]>(
    `purchase-orders-my-top-products-${period}-${take}`,
    () =>
      purchaseOrdersService.getMyTopProducts({
        period,
        take,
      } as unknown as Parameters<typeof purchaseOrdersService.getMyTopProducts>[0]),
  );
}
